const SWATCH_COLORS = {
  rosa: '#e7a1b5',
  'rosa pastel': '#f0c5d2',
  cherry: '#7b2432',
  blanco: '#ffffff',
  rojo: '#d93a3a',
  'verde agua': '#75cfc4',
  verde: '#4f8a5b',
  'verde olivo': '#78806a',
  olivo: '#78806a',
  amarillo: '#f2ca35',
  negro: '#171717',
  azul: '#3f83d8',
  'azul cielo': '#8fcaef',
  'azul rey': '#2f67c7',
  'azul marino': '#33435d',
  gris: '#9a9a9a',
  crema: '#eee4cf',
  beige: '#d8c7a5',
  morado: '#8062a8',
  lila: '#b8a4d9',
  pistache: '#b6cc85',
  limon: '#d8de45',
  fuchsia: '#d75c9f',
  fiusha: '#d75c9f',
  'verde rosa': 'linear-gradient(135deg, #4f8a5b 0 50%, #e7a1b5 50% 100%)',
  'rosa naranja': 'linear-gradient(135deg, #e7a1b5 0 50%, #ec8d4f 50% 100%)',
  'azul naranja': 'linear-gradient(135deg, #3f83d8 0 50%, #ec8d4f 50% 100%)',
  'azul morado': 'linear-gradient(135deg, #3f83d8 0 50%, #8062a8 50% 100%)',
  'rosa fiusha': 'linear-gradient(135deg, #e7a1b5 0 50%, #d75c9f 50% 100%)',
  'rosa fuchsia': 'linear-gradient(135deg, #e7a1b5 0 50%, #d75c9f 50% 100%)',
  'azul beige': 'linear-gradient(135deg, #3f83d8 0 50%, #d8c7a5 50% 100%)',
  'beige rosa': 'linear-gradient(135deg, #d8c7a5 0 50%, #e7a1b5 50% 100%)',
  'amarillo naranja': 'linear-gradient(135deg, #f2ca35 0 50%, #ec8d4f 50% 100%)',
  'verde azul': 'linear-gradient(135deg, #4f8a5b 0 50%, #3f83d8 50% 100%)',
  degradado: 'linear-gradient(135deg, #f3a8c5, #a4d2f4)',
  multicolor: 'linear-gradient(135deg, #f6a3b6 0%, #f9df8c 33%, #9ed7c1 66%, #9ebbe9 100%)',
  estampado: 'linear-gradient(135deg, #f3a8c5 0%, #f9df8c 33%, #9ed7c1 66%, #9ebbe9 100%)',
  mix: 'linear-gradient(135deg, #f3a8c5 0%, #f9df8c 33%, #9ed7c1 66%, #9ebbe9 100%)',
};

const normalizeColorName = (value = '') =>
  value
    .toLocaleLowerCase('es-MX')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[\/_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const normalizeColorMap = (colorMap) =>
  Object.fromEntries(Object.entries(colorMap).map(([name, color]) => [normalizeColorName(name), color]));

const reportedMissingSwatches = new Set();

const parseColorMap = (picker) => {
  try {
    return { ...normalizeColorMap(SWATCH_COLORS), ...normalizeColorMap(JSON.parse(picker.dataset.droplandColorMap || '{}')) };
  } catch (error) {
    console.warn('Dropland color map is not valid JSON. Using default colors.', error);
    return normalizeColorMap(SWATCH_COLORS);
  }
};

const updateColorPicker = (picker) => {
  const colorOption = picker.querySelector('.dropland-color-option');
  const swatchPicker = picker.querySelector('[data-dropland-color-swatch-picker]');
  if (!colorOption || !swatchPicker) return;

  const colorMap = parseColorMap(picker);
  swatchPicker.querySelectorAll('[data-dropland-color-name]').forEach((button) => {
    const colorName = normalizeColorName(button.dataset.droplandColorName || '');
    const colorValue = colorMap[colorName] || button.dataset.droplandNativeSwatchColor;
    // Ritual morphs the variant picker after a variant update. Keep the color
    // on each individual button so a newly rendered picker never falls back
    // to the neutral default swatch color.
    if (colorValue) {
      button.style.setProperty('--swatch-color', colorValue);
      button.removeAttribute('data-dropland-swatch-unconfigured');
    } else {
      button.style.removeProperty('--swatch-color');
      button.setAttribute('data-dropland-swatch-unconfigured', 'true');

      if (!reportedMissingSwatches.has(colorName)) {
        console.warn(`Swatch sin color configurado: ${button.dataset.droplandColorName}`);
        reportedMissingSwatches.add(colorName);
      }
    }
  });

  const selected = colorOption.querySelector('input:checked');
  const selectedName = colorOption.querySelector('[data-dropland-selected-color]');
  const visibleSelectedName = swatchPicker.querySelector('[data-dropland-visible-selected-color]');
  if (!selected) return;

  if (selectedName) selectedName.textContent = selected.value;
  if (visibleSelectedName) visibleSelectedName.textContent = selected.value;
  swatchPicker.querySelectorAll('[data-option-value-id]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.optionValueId === selected.dataset.optionValueId));
  });
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-dropland-color-swatch-picker] [data-option-value-id]');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  const picker = button.closest('variant-picker');
  if (!picker) return;

  const nativeInput = Array.from(picker.querySelectorAll('.dropland-color-option input')).find(
    (input) => input.dataset.optionValueId === button.dataset.optionValueId
  );
  if (!(nativeInput instanceof HTMLInputElement) || nativeInput.disabled) return;

  nativeInput.checked = true;
  nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLInputElement)) return;
  const picker = event.target.closest('variant-picker');
  if (picker?.querySelector('.dropland-color-option')) updateColorPicker(picker);
});

// This event is dispatched by Ritual after it has morphed the updated variant
// picker into the page. Reapply the per-swatch custom properties to the new
// DOM nodes; selection state must not affect any swatch's own color.
document.addEventListener('variant:update', (event) => {
  if (!(event.target instanceof HTMLElement)) return;

  const picker = event.target.closest('variant-picker');
  if (picker?.querySelector('.dropland-color-option')) updateColorPicker(picker);
});

document.querySelectorAll('variant-picker').forEach(updateColorPicker);
